var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5682 16.542C49.4483 18.0664 49.3303 19.8816 48.2591 21.2787L24.7408 51.9687C23.7708 53.2342 22.1738 53.8794 20.5408 53.566C18.9416 53.2584 17.6736 52.0927 17.2336 50.5249L13.7537 38.1397L13.3913 36.8515L12.4568 35.8935L3.47097 26.6873C2.33318 25.5223 1.95764 23.8413 2.49087 22.3026C3.01862 20.7816 4.34225 19.6779 5.97418 19.464L44.3117 14.4415C46.0572 14.2123 47.6881 15.0177 48.5682 16.542Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7541 38.1388L17.2339 50.524C17.6739 52.0919 18.9419 53.2575 20.5411 53.5652C22.1742 53.8787 23.7712 53.2335 24.7411 51.9678L48.2594 21.2779C49.3306 19.8808 49.4486 18.0656 48.5685 16.5412L13.3916 36.8506L13.7541 38.1388Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7064 28.5852C28.0643 29.2051 27.8525 29.9984 27.2317 30.3568L13.7541 38.1381L13.3917 36.8498L12.4573 35.8918L25.9349 28.1106C26.5556 27.7523 27.3485 27.9653 27.7064 28.5852Z",
    fill: "url(#paint0_linear_2038_21887)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7541 38.1392L27.2317 30.3579C27.8524 29.9996 28.0644 29.2064 27.7064 28.5864L13.3917 36.851L13.7541 38.1392Z",
    fill: "url(#paint1_linear_2038_21887)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2038_21887",
    x1: 22.849,
    y1: 29.9762,
    x2: 24.2972,
    y2: 32.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3BE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2038_21887",
    x1: 23.4793,
    y1: 31.0689,
    x2: 24.2483,
    y2: 32.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E3BE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.2cd9d539101005c76059b0caa11441d3.svg";
export { ForwardRef as ReactComponent };